<template>
    <tr v-if="o === n">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td v-if="output ==='input'" width="100%"><input type="text" v-model="res" disabled/></td>
                    <td v-else width="100%"><textarea rows="1" v-model="res" disabled/></td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': res === o}" style="padding: 0 5px;">
            <a @click="changeResult(o)">
                {{ o }}
                <i v-if="(o === '') || (o === null)">✕</i>
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td v-if="output ==='input'" width="100%"><input type="text" v-model="res" disabled/></td>
                    <td v-else width="100%"><textarea rows="1" v-model="res" disabled/></td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': res === n}" style="padding: 0 5px;">
            <a @click="changeResult(n)">
                {{ n }}
                <i v-if="(n === '') || (n === null)">✕</i>
            </a>
        </td>
    </tr>
</template>

<script>
    //TODO какой ужас, компонент накостылен над костылями, простите сроки поджимали, нужно переписать всю склейку
    import Base from "../Base.vue";
    import StrPropsFNO from "../StrPropsFNO.vue";
    export default {
        name: "Info",
        mixins: [
            Base,
            StrPropsFNO
        ],
        beforeMount() {
            if (this.$store.state.glueClinics.doctorsMerge && !this.dontNeedSumm()) {
                this.res = this.n + this.o;
            } else {
                this.res = this.n;
            }
        },
        data() {
            return {
                prefix: this.params.prefix ?? '',
                suffix: this.params.suffix ?? '',
                output: this.params.output ?? '',
            }
        },
        computed: {
            doctorsMerge() {
                return this.$store.state.glueClinics.doctorsMerge;
            },
        },
        methods: {
            //Удалить при доработке склейке клиник
            dontNeedSumm() {
                if (['socialVk', 'email', 'socialFb', 'socialInsta', 'socialOk', 'socialYoutube'].includes(this.params.key)) {
                    return true;
                }

                return false;
            },
            changeResult(object) {
                if (this.dontNeedSumm()) {
                    this.res = object;
                }
            }
        },
        watch: {
            doctorsMerge(value) {
                if (!this.dontNeedSumm()) {
                    if (value) {
                        this.res = this.n + this.o;
                    } else {
                        this.res = this.n;
                    }
                } else {
                    this.res = value
                }
            }
        }
    }
</script>

<style scoped>

</style>
